import axios, { AxiosResponse } from 'axios';

import { EEvidenceCp } from 'enums/isin/evidenceCp';
import { ECisalikvynos } from 'enums/isin/udaje/cisalikvynos';
import { EDruhCp } from 'enums/isin/udaje/druhCp';
import { EkonecVyporadani } from 'enums/isin/udaje/konecVyporadani';

export interface IPostupnesplaceni {
    datumsplatnosti?: string;
    mtno?: number;
    dnom?: string;
}

export enum EKolInvestovaniDruh {
    AKCIESICAV = 'AKCIESICAV',
    AKCIEUIF = 'AKCIEUIF'
}

export interface IEmisniUdaje {
    hlprava?: string;
    druhakcie?: string;
    druhvynosu?: string;
    druhnastroje?: EKolInvestovaniDruh;
    pravidlaodkupu?: string;
    jmeno?: string;
    prijmeni?: string;
    druhdluhopisu?: string;
    druhdluhopiscfi?: string;
    emisnipodminky?: string;
    doplninformace?: string;
    urokovasazba?: string;
    urokovasazbapopis?: string;
    fixnisazba?: number;
    pocetkuponu?: number;
    datumsplatnosti?: string;
    zahremitent?: boolean | string;
    prioritni?: boolean | string;
    vymenitelny?: boolean | string;
    perpetuitni?: boolean | string;
    podrizeny?: boolean | string;
    oddelenikuponu?: boolean | string;
    pridelitnavse?: boolean | string;
    podminkysdatumem?: boolean | string;
    frekvencevyplaty?: string;
    zaruceniemise?: string;
    zaruceniemisewar?: string;
    zkracenynazev?: string;
    typpodillistu?: string;
    pouzitizisku?: string;
    druhaktivit?: string;
    omezeniinvest?: string;
    nav?: number;
    podkladaktivum?: string;
    typwarrantu?: string;
    warrnakupprodej?: string;
    uplatneniopce?: string;
    druhwarrantu?: string;
    jinasazba?: string;
    predcassplatnost?: boolean | string;
    dnom?: string;
    mtno?: number;
    druhcertifikatu?: string;
    typcertifikatu?: string;
    vyplaty?: string;
    splaceni?: string;
    podkladaktivita?: string;
    typzavnabariere?: string;
    dlouhekratke?: string;
    druhuplatneni?: string;
    nbti?: number;
    jinaosoba?: string;
    jinaosobaid?: string;
    formacp?: string;
    ompr?: boolean | string;
    omprpopis?: string;
    zasadyvyplaty?: string;
    druhfondinvestuje?: string;
    typcpproinvestory?: string;
    jinepopis?: string;
    akciepopis?: string;
    datumkurzu?: string;
    podkladaktiva?: { isin: string }[];
    vymennypomer?: number | string;
    strikecena?: string | number;
    strikemena?: string;
    menavyporadani?: string;
    alikvynos?: ECisalikvynos;
    alikvynospopis?: string;
    postupnesplaceni?: IPostupnesplaceni[];
    multiplikator?: number | string;
    konecvyporadani?: EkonecVyporadani;
    evidencecp?: EEvidenceCp;
    podobacp?: string;
    druhdlefondu?: string;
    tridapl?: string;
    duvod?: string;
}

export enum ESendEmisniUdaje {
    AKCIE = 'Akcie',
    DLUHOPIS = 'Dluhopis',
    PODILLIST = 'Podilovylist',
    INVCERT = 'Investicnicertifikat',
    WARRANT = 'Warrant',
    NASTROJKOLINV = 'Nastrojkolektivnihoinv',
    JINYINVNASTROJ = 'Jineinvnastroje',
    PREDNOSTNIPRAVO = 'Jineinvnastroje',
    PRAVOUPSANI = 'Jineinvnastroje',
    ZATIMNILISTY = 'Jineinvnastroje',
    OSTATNI = 'Jineinvnastroje'
}

const novyIsinSend = (idZadosti: number) => {
    return axios({
        method: 'POST',
        url: `/ZadostoISIN/${idZadosti}/Send`
    });
};

export interface IListIsin {
    cval: string;
    eico: string;
    enma: string;
    tval: string;
    pcot: string;
    data: string;
    druhcp: EDruhCp;
}

export const getIsinList = () => {
    return axios({
        method: 'GET',
        url: 'ISIN/List'
    }).then((resp: AxiosResponse<{ isininfos: IListIsin[] }>) => resp.data);
};

export const emisniUdaje = (
    method: 'get' | 'post' | 'put',
    oblast: ESendEmisniUdaje,
    idZadosti: number,
    data?: IEmisniUdaje
) => {
    return axios({
        method: method,
        url: `ZadostoISIN${oblast}/${idZadosti}`,
        data: data
    }).then((resp: AxiosResponse<IEmisniUdaje>) => resp.data);
};

export default novyIsinSend;
